import { z } from "zod";
import { NonEmptyStringSchema } from "../common/dto";

/**
 * Crew module DTOs
 * Shared types between backend and frontend for crew-related endpoints
 */

// ============= Response Schemas =============

/**
 * Schema for a short crew (id and name only)
 * Used when crew information is embedded in other responses (e.g., UserCrew)
 */
export const ShortCrewSchema = z.object({
  id: z.number().int().positive(),
  name: NonEmptyStringSchema,
});

// ============= Type Exports =============

export type ShortCrew = z.infer<typeof ShortCrewSchema>;
